/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Policy_Number_TooltipInputs */

const en_claims_policy_number_tooltip = /** @type {(inputs: Claims_Policy_Number_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Policy number can be found in the policy confirmation email`)
};

const fr_claims_policy_number_tooltip = /** @type {(inputs: Claims_Policy_Number_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le numéro de police se trouve dans le courriel de confirmation de police`)
};

/**
* | output |
* | --- |
* | "Policy number can be found in the policy confirmation email" |
*
* @param {Claims_Policy_Number_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_policy_number_tooltip = /** @type {((inputs?: Claims_Policy_Number_TooltipInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Policy_Number_TooltipInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_policy_number_tooltip(inputs)
	return fr_claims_policy_number_tooltip(inputs)
});